/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Plaintext_LabelInputs */



/**
* | output |
* | --- |
* | "Plain Text" |
*
* @param {File_Import_Plaintext_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_plaintext_label = /** @type {((inputs?: File_Import_Plaintext_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Plaintext_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plain Text")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klartext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo normale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Простой текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto sin formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("纯文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーンテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सादे पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto simples")
	return /** @type {LocalizedString} */ ("Plain Text")
});